import { AuthStatusDelegate } from "../AuthStatusService/auth-status.delegate"
import { AuthStatusService } from "../AuthStatusService/auth-status.service"
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';

export class AuthStatusServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService
    ): AuthStatusService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const authDelegate = new AuthStatusDelegate(httpProvider);

        return new AuthStatusService(authDelegate, authenticationService);
    }
}